//船运单
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class State extends UltMeta {
    DEPOSIT_TO_BE_PAID = new Meta(10, "定金确认中");
    // SHIP_INFO_FEE_TO_BE_PAID = new Meta(9, "待付信息服务费");
    // 服务费确认中只用于查询 实际数据库并不存在此状态
    // SHIP_INFO_FEE_CONFIRMING = new Meta(11, "信息服务费确认中");
    TO_BE_LOADED = new Meta(1, "待装货");
    // DURING_LOADING = new Meta(2, "装货中");
    AWAITING_DEPARTURE = new Meta(3, "待发航");
    DURING_TRANSPORTATION = new Meta(4, "运输中");
    TO_BE_UNLOADED = new Meta(5, "待卸货");
    // DURING_UNLOADING = new Meta(6, "卸货中");
    DISCHARGED = new Meta(7, "已清仓");
    COMPLETED = new Meta(8, "已完成");
    UNCOMPLETED = new Meta(13, "未完成");
}

export const STATE = new State();

/**
 * 类型
 */
class Type extends UltMeta {
    PLATFORM_CREATION = new Meta(1, "平台创建");
    SHIP_OWNER_TAKES_ORDERS = new Meta(2, "船主接单");
}

export const TYPE = new Type();

class QueryType extends UltMeta {
    SHIPPER = new Meta(1, "船主");
    SHIPOWNER = new Meta(2, "货主");
}

export const QUERY_TYPE = new QueryType();

/**
 * 服务专员类型
 */
class ServiceSpecialsType extends UltMeta {
    UPSTREAM_HANDLER = new Meta(1, "上游处理专员");
    DOWNSTREAM_HANDLER = new Meta(2, "下游处理专员");
}

export const SERVICE_SPECIALS_TYPE = new ServiceSpecialsType();

/**
 * 支付类型
 */
class DepositPayType extends UltMeta {
    PAY_ONESELF = new Meta(1, "自行支付");
    PAY_ZH = new Meta(2, "服务商垫付(黄码港网络货运平台)");
}

export const DEPOSIT_PAY_TYPE = new DepositPayType();

/**
 * 运费结算吨位确认节点
 */
class FreightSettleTonConfirmNode extends UltMeta {
    AWAITING_DEPARTURE = new Meta(1, "待发航");
    TO_BE_UNLOADED = new Meta(2, "待卸货");
}

export const FREIGHT_SETTLE_TON_CONFIRM_NODE = new FreightSettleTonConfirmNode();

/**
 * 海事费用
 */
class MaritimeAffairsFee extends UltMeta {
    SHIPPERS_BEAR_UPSTREAM = new Meta(1, "货主承担上游");
    SHIPPERS_BEAR_DOWNSTREAM = new Meta(2, "货主承担下游");
    SHIPPERS_BEAR_BOTH_PORTS = new Meta(3, "货主承担两港");
    SHIPPERS_NOT_RESPONSIBLE = new Meta(4, "货主不承担");
}

export const MARITIME_AFFAIRS_FEE = new MaritimeAffairsFee();

/**
 * 黄码港审核状态
 */
class HmgCheckState extends UltMeta {
    PENDING_REVIEW = new Meta(1, "待审核");
    APPROVED = new Meta(2, "审核通过");
    REJECTED = new Meta(3, "审核不通过");
}
export const HMG_CHECK_STATE = new HmgCheckState();

// 签好运-运单合同代收协议签署状态
class QhySignState extends UltMeta {
    UNSIGNED = new Meta(0, "未签署");
    SIGNED = new Meta(1, "已签署");
}
export const QHY_SIGN_STATE = new QhySignState();
